import { Form } from "antd"
import { Alert, RadioButtons } from "components/common"
import { t } from "i18next"
import { useMemo } from "react"
import AccountantSection from "features/leads/components/addSalesModal/components/addSalesForm/components/paymentSection/components/AccountantSection"
import { PAYMENTS_FORM_LIST_NAME } from "features/leads/components/addSalesModal/components/addSalesForm/components/paymentSection/utils/paymentUtils"
import { fractionalDepositByRadioOptions } from "../utilis"
import { PSID_INFO, psidAlertStyle } from "../utilis/psidInfo"

export default function FractionalPsidDepositByBlock({
  form,
  listFieldName,
  getAccountant,
  accountantData,
  isLoadingAccountant,
  platformKey,
  projectId,
  formItemClassName,
  isRaFlowEnabled,
}) {
  const fullPath = useMemo(() => [PAYMENTS_FORM_LIST_NAME, listFieldName], [listFieldName])
  const enableDepositRA = Form.useWatch([...fullPath, "enableDepositRA"], form)

  const depositByOptions = useMemo(() => fractionalDepositByRadioOptions(isRaFlowEnabled), [isRaFlowEnabled])

  return (
    <>
      <Form.Item
        className={formItemClassName}
        preserve
        name={[listFieldName, "enableDepositRA"]}
        initialValue={false}
        label={t("Deposit By")}
        rules={[
          {
            validator: (_, v) =>
              v === true || v === false ? Promise.resolve() : Promise.reject(t("Deposit by is required")),
          },
        ]}
      >
        <RadioButtons
          getValue={item => item.key}
          options={depositByOptions}
          onChange={e => {
            if (e?.target?.value === true) getAccountant(null, true)
          }}
        />
      </Form.Item>
      {!!isRaFlowEnabled && !!enableDepositRA && (
        <AccountantSection
          form={form}
          accountantData={accountantData}
          isLoadingAccountant={isLoadingAccountant}
          platformKey={platformKey}
          projectId={projectId}
          listFieldName={listFieldName}
        />
      )}
      <Alert type="info" message={<PSID_INFO />} style={psidAlertStyle} />
    </>
  )
}
